module.exports = __webpack_public_path__ + "img/cardFiveImg.a54afa0c.png";